import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Post from '../components/Post';
import { connect } from 'react-redux'
import { setStoryTitle } from '../state/app'

class PostTemplate extends Component {
    render() {
        this.props.dispatch(setStoryTitle(this.props.data.mdx.frontmatter.title));

        const {
            title: siteTitle,
        } = this.props.data.site.siteMetadata;

        const {
            title: postTitle,
            author: postAuthor,
        } = this.props.data.mdx.frontmatter;

        return (
            <Post 
                pageTitle={`${postTitle} - ${postAuthor} - ${siteTitle}`} 
                post={this.props.data.mdx} 
                location={this.props.location}/>
        );
    }
};

export const query = graphql`
    query PostBySlug($slug: String!) {
        site {
            siteMetadata {
                title
            }
        }
        mdx(fields: { slug: { eq: $slug } }) {
            body
            fields {
                image {
                    childImageSharp {
                        fixed(width: 200, height: 275) {
                            ...GatsbyImageSharpFixed
                        }
                        fluid {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
                audio {
                    publicURL
                }
            }
            frontmatter {
                title
                author
                tags
            }
            tableOfContents
            excerpt
        }
    }
`;

export default connect(null, null)(PostTemplate)
